//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { PropertyModel } from './PropertyModel';
  import { TermModel } from './TermModel';
  import { RelationshipModel } from './RelationshipModel';
  
  export class ConceptWorkspaceModel extends ModelBase {
      static readonly $typeName = 'ConceptWorkspaceModel';
      public conceptVersionKey: string;
      public conceptCode: string;
      public properties: PropertyModel[];
      public terms: TermModel[];
      public relationships: RelationshipModel[];
      public canEdit: boolean;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/ConceptWorkspaceModel.ts